import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthShell } from "./Login";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const { data } = await api.post("/auth/verify-email", { token });
        setMessage(data.message);
        setState("ok");
      } catch (err) {
        setMessage(formatApiError(err.response?.data?.detail));
        setState("error");
      }
    })();
  }, [token]);

  return (
    <AuthShell>
      <div className="text-center" data-testid="verify-email-result">
        {state === "loading" && <Loader2 className="h-10 w-10 text-slate-400 mx-auto mb-4 animate-spin" aria-hidden="true" />}
        {state === "ok" && <CheckCircle2 className="h-10 w-10 text-emerald-600 mx-auto mb-4" aria-hidden="true" />}
        {state === "error" && <XCircle className="h-10 w-10 text-destructive mx-auto mb-4" aria-hidden="true" />}
        <h1 className="font-heading text-2xl font-bold tracking-tight mb-2">
          {state === "loading" ? "Verifying…" : state === "ok" ? "Email verified" : "Verification failed"}
        </h1>
        <p className="text-sm text-muted-foreground">{message}</p>
        <Button asChild className="mt-6 rounded-md"><Link to="/login">Go to sign in</Link></Button>
      </div>
    </AuthShell>
  );
}
